webpackJsonp([212839066777427,10495410396556],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mfg-account_login-min-1.3a8fa4b6.png";

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useMatch = exports.useParams = exports.useNavigate = exports.useLocation = exports.matchPath = exports.globalHistory = exports.redirectTo = exports.navigate = exports.isRedirect = exports.createMemorySource = exports.createHistory = exports.ServerLocation = exports.Router = exports.Redirect = exports.Match = exports.LocationProvider = exports.Location = exports.Link = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(5);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createReactContext = __webpack_require__(83);
	
	var _createReactContext2 = _interopRequireDefault(_createReactContext);
	
	var _reactLifecyclesCompat = __webpack_require__(95);
	
	var _utils = __webpack_require__(54);
	
	var _history = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/anchor-has-content */
	
	
	////////////////////////////////////////////////////////////////////////////////
	
	var createNamedContext = function createNamedContext(name, defaultValue) {
	  var Ctx = (0, _createReactContext2.default)(defaultValue);
	  Ctx.displayName = name;
	  return Ctx;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Location Context/Provider
	var LocationContext = createNamedContext("Location");
	
	// sets up a listener if there isn't one already so apps don't need to be
	// wrapped in some top level provider
	var Location = function Location(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    LocationContext.Consumer,
	    null,
	    function (context) {
	      return context ? children(context) : _react2.default.createElement(
	        LocationProvider,
	        null,
	        children
	      );
	    }
	  );
	};
	
	var LocationProvider = function (_React$Component) {
	  _inherits(LocationProvider, _React$Component);
	
	  function LocationProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LocationProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      context: _this.getContext(),
	      refs: { unlisten: null }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LocationProvider.prototype.getContext = function getContext() {
	    var _props$history = this.props.history,
	        navigate = _props$history.navigate,
	        location = _props$history.location;
	
	    return { navigate: navigate, location: location };
	  };
	
	  LocationProvider.prototype.componentDidCatch = function componentDidCatch(error, info) {
	    if (isRedirect(error)) {
	      var _navigate = this.props.history.navigate;
	
	      _navigate(error.uri, { replace: true });
	    } else {
	      throw error;
	    }
	  };
	
	  LocationProvider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevState.context.location !== this.state.context.location) {
	      this.props.history._onTransitionComplete();
	    }
	  };
	
	  LocationProvider.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var refs = this.state.refs,
	        history = this.props.history;
	
	    history._onTransitionComplete();
	    refs.unlisten = history.listen(function () {
	      Promise.resolve().then(function () {
	        // TODO: replace rAF with react deferred update API when it's ready https://github.com/facebook/react/issues/13306
	        requestAnimationFrame(function () {
	          if (!_this2.unmounted) {
	            _this2.setState(function () {
	              return { context: _this2.getContext() };
	            });
	          }
	        });
	      });
	    });
	  };
	
	  LocationProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    var refs = this.state.refs;
	
	    this.unmounted = true;
	    refs.unlisten();
	  };
	
	  LocationProvider.prototype.render = function render() {
	    var context = this.state.context,
	        children = this.props.children;
	
	    return _react2.default.createElement(
	      LocationContext.Provider,
	      { value: context },
	      typeof children === "function" ? children(context) : children || null
	    );
	  };
	
	  return LocationProvider;
	}(_react2.default.Component);
	
	////////////////////////////////////////////////////////////////////////////////
	
	
	LocationProvider.defaultProps = {
	  history: _history.globalHistory
	};
	 false ? LocationProvider.propTypes = {
	  history: _propTypes2.default.object.isRequired
	} : void 0;
	var ServerLocation = function ServerLocation(_ref2) {
	  var url = _ref2.url,
	      children = _ref2.children;
	
	  var searchIndex = url.indexOf("?");
	  var searchExists = searchIndex > -1;
	  var pathname = void 0;
	  var search = "";
	  var hash = "";
	
	  if (searchExists) {
	    pathname = url.substring(0, searchIndex);
	    search = url.substring(searchIndex);
	  } else {
	    pathname = url;
	  }
	
	  return _react2.default.createElement(
	    LocationContext.Provider,
	    {
	      value: {
	        location: {
	          pathname: pathname,
	          search: search,
	          hash: hash
	        },
	        navigate: function navigate() {
	          throw new Error("You can't call navigate on the server.");
	        }
	      }
	    },
	    children
	  );
	};
	////////////////////////////////////////////////////////////////////////////////
	// Sets baseuri and basepath for nested routers and links
	var BaseContext = createNamedContext("Base", { baseuri: "/", basepath: "/" });
	
	////////////////////////////////////////////////////////////////////////////////
	// The main event, welcome to the show everybody.
	var Router = function Router(props) {
	  return _react2.default.createElement(
	    BaseContext.Consumer,
	    null,
	    function (baseContext) {
	      return _react2.default.createElement(
	        Location,
	        null,
	        function (locationContext) {
	          return _react2.default.createElement(RouterImpl, _extends({}, baseContext, locationContext, props));
	        }
	      );
	    }
	  );
	};
	
	var RouterImpl = function (_React$PureComponent) {
	  _inherits(RouterImpl, _React$PureComponent);
	
	  function RouterImpl() {
	    _classCallCheck(this, RouterImpl);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  RouterImpl.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        _navigate2 = _props.navigate,
	        basepath = _props.basepath,
	        primary = _props.primary,
	        children = _props.children,
	        baseuri = _props.baseuri,
	        _props$component = _props.component,
	        component = _props$component === undefined ? "div" : _props$component,
	        domProps = _objectWithoutProperties(_props, ["location", "navigate", "basepath", "primary", "children", "baseuri", "component"]);
	
	    var routes = _react2.default.Children.toArray(children).reduce(function (array, child) {
	      var routes = createRoute(basepath)(child);
	      return array.concat(routes);
	    }, []);
	    var pathname = location.pathname;
	
	
	    var match = (0, _utils.pick)(routes, pathname);
	
	    if (match) {
	      var params = match.params,
	          uri = match.uri,
	          route = match.route,
	          element = match.route.value;
	
	      // remove the /* from the end for child routes relative paths
	
	      basepath = route.default ? basepath : route.path.replace(/\*$/, "");
	
	      var props = _extends({}, params, {
	        uri: uri,
	        location: location,
	        navigate: function navigate(to, options) {
	          return _navigate2((0, _utils.resolve)(to, uri), options);
	        }
	      });
	
	      var clone = _react2.default.cloneElement(element, props, element.props.children ? _react2.default.createElement(
	        Router,
	        { location: location, primary: primary },
	        element.props.children
	      ) : undefined);
	
	      // using 'div' for < 16.3 support
	      var FocusWrapper = primary ? FocusHandler : component;
	      // don't pass any props to 'div'
	      var wrapperProps = primary ? _extends({ uri: uri, location: location, component: component }, domProps) : domProps;
	
	      return _react2.default.createElement(
	        BaseContext.Provider,
	        { value: { baseuri: uri, basepath: basepath } },
	        _react2.default.createElement(
	          FocusWrapper,
	          wrapperProps,
	          clone
	        )
	      );
	    } else {
	      // Not sure if we want this, would require index routes at every level
	      // warning(
	      //   false,
	      //   `<Router basepath="${basepath}">\n\nNothing matched:\n\t${
	      //     location.pathname
	      //   }\n\nPaths checked: \n\t${routes
	      //     .map(route => route.path)
	      //     .join(
	      //       "\n\t"
	      //     )}\n\nTo get rid of this warning, add a default NotFound component as child of Router:
	      //   \n\tlet NotFound = () => <div>Not Found!</div>
	      //   \n\t<Router>\n\t  <NotFound default/>\n\t  {/* ... */}\n\t</Router>`
	      // );
	      return null;
	    }
	  };
	
	  return RouterImpl;
	}(_react2.default.PureComponent);
	
	RouterImpl.defaultProps = {
	  primary: true
	};
	
	
	var FocusContext = createNamedContext("Focus");
	
	var FocusHandler = function FocusHandler(_ref3) {
	  var uri = _ref3.uri,
	      location = _ref3.location,
	      component = _ref3.component,
	      domProps = _objectWithoutProperties(_ref3, ["uri", "location", "component"]);
	
	  return _react2.default.createElement(
	    FocusContext.Consumer,
	    null,
	    function (requestFocus) {
	      return _react2.default.createElement(FocusHandlerImpl, _extends({}, domProps, {
	        component: component,
	        requestFocus: requestFocus,
	        uri: uri,
	        location: location
	      }));
	    }
	  );
	};
	
	// don't focus on initial render
	var initialRender = true;
	var focusHandlerCount = 0;
	
	var FocusHandlerImpl = function (_React$Component2) {
	  _inherits(FocusHandlerImpl, _React$Component2);
	
	  function FocusHandlerImpl() {
	    var _temp2, _this4, _ret2;
	
	    _classCallCheck(this, FocusHandlerImpl);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this4), _this4.state = {}, _this4.requestFocus = function (node) {
	      if (!_this4.state.shouldFocus && node) {
	        node.focus();
	      }
	    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	  }
	
	  FocusHandlerImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	    var initial = prevState.uri == null;
	    if (initial) {
	      return _extends({
	        shouldFocus: true
	      }, nextProps);
	    } else {
	      var myURIChanged = nextProps.uri !== prevState.uri;
	      var navigatedUpToMe = prevState.location.pathname !== nextProps.location.pathname && nextProps.location.pathname === nextProps.uri;
	      return _extends({
	        shouldFocus: myURIChanged || navigatedUpToMe
	      }, nextProps);
	    }
	  };
	
	  FocusHandlerImpl.prototype.componentDidMount = function componentDidMount() {
	    focusHandlerCount++;
	    this.focus();
	  };
	
	  FocusHandlerImpl.prototype.componentWillUnmount = function componentWillUnmount() {
	    focusHandlerCount--;
	    if (focusHandlerCount === 0) {
	      initialRender = true;
	    }
	  };
	
	  FocusHandlerImpl.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.location !== this.props.location && this.state.shouldFocus) {
	      this.focus();
	    }
	  };
	
	  FocusHandlerImpl.prototype.focus = function focus() {
	    if (false) {
	      // getting cannot read property focus of null in the tests
	      // and that bit of global `initialRender` state causes problems
	      // should probably figure it out!
	      return;
	    }
	
	    var requestFocus = this.props.requestFocus;
	
	
	    if (requestFocus) {
	      requestFocus(this.node);
	    } else {
	      if (initialRender) {
	        initialRender = false;
	      } else if (this.node) {
	        // React polyfills [autofocus] and it fires earlier than cDM,
	        // so we were stealing focus away, this line prevents that.
	        if (!this.node.contains(document.activeElement)) {
	          this.node.focus();
	        }
	      }
	    }
	  };
	
	  FocusHandlerImpl.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props2 = this.props,
	        children = _props2.children,
	        style = _props2.style,
	        requestFocus = _props2.requestFocus,
	        _props2$component = _props2.component,
	        Comp = _props2$component === undefined ? "div" : _props2$component,
	        uri = _props2.uri,
	        location = _props2.location,
	        domProps = _objectWithoutProperties(_props2, ["children", "style", "requestFocus", "component", "uri", "location"]);
	
	    return _react2.default.createElement(
	      Comp,
	      _extends({
	        style: _extends({ outline: "none" }, style),
	        tabIndex: "-1",
	        ref: function ref(n) {
	          return _this5.node = n;
	        }
	      }, domProps),
	      _react2.default.createElement(
	        FocusContext.Provider,
	        { value: this.requestFocus },
	        this.props.children
	      )
	    );
	  };
	
	  return FocusHandlerImpl;
	}(_react2.default.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(FocusHandlerImpl);
	
	var k = function k() {};
	
	////////////////////////////////////////////////////////////////////////////////
	var forwardRef = _react2.default.forwardRef;
	
	if (typeof forwardRef === "undefined") {
	  forwardRef = function forwardRef(C) {
	    return C;
	  };
	}
	
	var Link = forwardRef(function (_ref4, ref) {
	  var innerRef = _ref4.innerRef,
	      props = _objectWithoutProperties(_ref4, ["innerRef"]);
	
	  return _react2.default.createElement(
	    BaseContext.Consumer,
	    null,
	    function (_ref5) {
	      var basepath = _ref5.basepath,
	          baseuri = _ref5.baseuri;
	      return _react2.default.createElement(
	        Location,
	        null,
	        function (_ref6) {
	          var location = _ref6.location,
	              navigate = _ref6.navigate;
	
	          var to = props.to,
	              state = props.state,
	              replace = props.replace,
	              _props$getProps = props.getProps,
	              getProps = _props$getProps === undefined ? k : _props$getProps,
	              anchorProps = _objectWithoutProperties(props, ["to", "state", "replace", "getProps"]);
	
	          var href = (0, _utils.resolve)(to, baseuri);
	          var encodedHref = encodeURI(href);
	          var isCurrent = location.pathname === encodedHref;
	          var isPartiallyCurrent = (0, _utils.startsWith)(location.pathname, encodedHref);
	
	          return _react2.default.createElement("a", _extends({
	            ref: ref || innerRef,
	            "aria-current": isCurrent ? "page" : undefined
	          }, anchorProps, getProps({ isCurrent: isCurrent, isPartiallyCurrent: isPartiallyCurrent, href: href, location: location }), {
	            href: href,
	            onClick: function onClick(event) {
	              if (anchorProps.onClick) anchorProps.onClick(event);
	              if (shouldNavigate(event)) {
	                event.preventDefault();
	                var shouldReplace = replace;
	                if (typeof replace !== "boolean" && isCurrent) {
	                  var _location$state = _extends({}, location.state),
	                      key = _location$state.key,
	                      restState = _objectWithoutProperties(_location$state, ["key"]);
	
	                  shouldReplace = (0, _utils.shallowCompare)(_extends({}, state), restState);
	                }
	                navigate(href, {
	                  state: state,
	                  replace: shouldReplace
	                });
	              }
	            }
	          }));
	        }
	      );
	    }
	  );
	});
	
	Link.displayName = "Link";
	
	 false ? Link.propTypes = {
	  to: _propTypes2.default.string.isRequired
	} : void 0;
	
	////////////////////////////////////////////////////////////////////////////////
	function RedirectRequest(uri) {
	  this.uri = uri;
	}
	
	var isRedirect = function isRedirect(o) {
	  return o instanceof RedirectRequest;
	};
	
	var redirectTo = function redirectTo(to) {
	  throw new RedirectRequest(to);
	};
	
	var RedirectImpl = function (_React$Component3) {
	  _inherits(RedirectImpl, _React$Component3);
	
	  function RedirectImpl() {
	    _classCallCheck(this, RedirectImpl);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  // Support React < 16 with this hook
	  RedirectImpl.prototype.componentDidMount = function componentDidMount() {
	    var _props3 = this.props,
	        navigate = _props3.navigate,
	        to = _props3.to,
	        from = _props3.from,
	        _props3$replace = _props3.replace,
	        replace = _props3$replace === undefined ? true : _props3$replace,
	        state = _props3.state,
	        noThrow = _props3.noThrow,
	        baseuri = _props3.baseuri,
	        props = _objectWithoutProperties(_props3, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);
	
	    Promise.resolve().then(function () {
	      var resolvedTo = (0, _utils.resolve)(to, baseuri);
	      navigate((0, _utils.insertParams)(resolvedTo, props), { replace: replace, state: state });
	    });
	  };
	
	  RedirectImpl.prototype.render = function render() {
	    var _props4 = this.props,
	        navigate = _props4.navigate,
	        to = _props4.to,
	        from = _props4.from,
	        replace = _props4.replace,
	        state = _props4.state,
	        noThrow = _props4.noThrow,
	        baseuri = _props4.baseuri,
	        props = _objectWithoutProperties(_props4, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);
	
	    var resolvedTo = (0, _utils.resolve)(to, baseuri);
	    if (!noThrow) redirectTo((0, _utils.insertParams)(resolvedTo, props));
	    return null;
	  };
	
	  return RedirectImpl;
	}(_react2.default.Component);
	
	var Redirect = function Redirect(props) {
	  return _react2.default.createElement(
	    BaseContext.Consumer,
	    null,
	    function (_ref7) {
	      var baseuri = _ref7.baseuri;
	      return _react2.default.createElement(
	        Location,
	        null,
	        function (locationContext) {
	          return _react2.default.createElement(RedirectImpl, _extends({}, locationContext, { baseuri: baseuri }, props));
	        }
	      );
	    }
	  );
	};
	
	 false ? Redirect.propTypes = {
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.string.isRequired
	} : void 0;
	
	////////////////////////////////////////////////////////////////////////////////
	var Match = function Match(_ref8) {
	  var path = _ref8.path,
	      children = _ref8.children;
	  return _react2.default.createElement(
	    BaseContext.Consumer,
	    null,
	    function (_ref9) {
	      var baseuri = _ref9.baseuri;
	      return _react2.default.createElement(
	        Location,
	        null,
	        function (_ref10) {
	          var navigate = _ref10.navigate,
	              location = _ref10.location;
	
	          var resolvedPath = (0, _utils.resolve)(path, baseuri);
	          var result = (0, _utils.match)(resolvedPath, location.pathname);
	          return children({
	            navigate: navigate,
	            location: location,
	            match: result ? _extends({}, result.params, {
	              uri: result.uri,
	              path: path
	            }) : null
	          });
	        }
	      );
	    }
	  );
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Hooks
	
	var useLocation = function useLocation() {
	  var context = (0, _react.useContext)(LocationContext);
	
	  if (!context) {
	    throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
	  }
	
	  return context.location;
	};
	
	var useNavigate = function useNavigate() {
	  var context = (0, _react.useContext)(LocationContext);
	
	  if (!context) {
	    throw new Error("useNavigate hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
	  }
	
	  return context.navigate;
	};
	
	var useParams = function useParams() {
	  var context = (0, _react.useContext)(BaseContext);
	
	  if (!context) {
	    throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
	  }
	
	  var location = useLocation();
	
	  var results = (0, _utils.match)(context.basepath, location.pathname);
	
	  return results ? results.params : null;
	};
	
	var useMatch = function useMatch(path) {
	  if (!path) {
	    throw new Error("useMatch(path: string) requires an argument of a string to match against");
	  }
	  var context = (0, _react.useContext)(BaseContext);
	
	  if (!context) {
	    throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
	  }
	
	  var location = useLocation();
	
	  var resolvedPath = (0, _utils.resolve)(path, context.baseuri);
	  var result = (0, _utils.match)(resolvedPath, location.pathname);
	  return result ? _extends({}, result.params, {
	    uri: result.uri,
	    path: path
	  }) : null;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Junk
	var stripSlashes = function stripSlashes(str) {
	  return str.replace(/(^\/+|\/+$)/g, "");
	};
	
	var createRoute = function createRoute(basepath) {
	  return function (element) {
	    if (!element) {
	      return null;
	    }
	
	    if (element.type === _react2.default.Fragment && element.props.children) {
	      return _react2.default.Children.map(element.props.children, createRoute(basepath));
	    }
	    !(element.props.path || element.props.default || element.type === Redirect) ?  false ? (0, _invariant2.default)(false, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `" + element.type + "`") : (0, _invariant2.default)(false) : void 0;
	
	    !!(element.type === Redirect && (!element.props.from || !element.props.to)) ?  false ? (0, _invariant2.default)(false, "<Redirect from=\"" + element.props.from + "\" to=\"" + element.props.to + "\"/> requires both \"from\" and \"to\" props when inside a <Router>.") : (0, _invariant2.default)(false) : void 0;
	
	    !!(element.type === Redirect && !(0, _utils.validateRedirect)(element.props.from, element.props.to)) ?  false ? (0, _invariant2.default)(false, "<Redirect from=\"" + element.props.from + " to=\"" + element.props.to + "\"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.") : (0, _invariant2.default)(false) : void 0;
	
	    if (element.props.default) {
	      return { value: element, default: true };
	    }
	
	    var elementPath = element.type === Redirect ? element.props.from : element.props.path;
	
	    var path = elementPath === "/" ? basepath : stripSlashes(basepath) + "/" + stripSlashes(elementPath);
	
	    return {
	      value: element,
	      default: element.props.default,
	      path: element.props.children ? stripSlashes(path) + "/*" : path
	    };
	  };
	};
	
	var shouldNavigate = function shouldNavigate(event) {
	  return !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	////////////////////////////////////////////////////////////////////////
	exports.Link = Link;
	exports.Location = Location;
	exports.LocationProvider = LocationProvider;
	exports.Match = Match;
	exports.Redirect = Redirect;
	exports.Router = Router;
	exports.ServerLocation = ServerLocation;
	exports.createHistory = _history.createHistory;
	exports.createMemorySource = _history.createMemorySource;
	exports.isRedirect = isRedirect;
	exports.navigate = _history.navigate;
	exports.redirectTo = redirectTo;
	exports.globalHistory = _history.globalHistory;
	exports.matchPath = _utils.match;
	exports.useLocation = useLocation;
	exports.useNavigate = useNavigate;
	exports.useParams = useParams;
	exports.useMatch = useMatch;

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getLocation = function getLocation(source) {
	  var _source$location = source.location,
	      search = _source$location.search,
	      hash = _source$location.hash,
	      href = _source$location.href,
	      origin = _source$location.origin,
	      protocol = _source$location.protocol,
	      host = _source$location.host,
	      hostname = _source$location.hostname,
	      port = _source$location.port;
	  var pathname = source.location.pathname;
	
	
	  if (!pathname && href && canUseDOM) {
	    var url = new URL(href);
	    pathname = url.pathname;
	  }
	
	  return {
	    pathname: encodeURI(decodeURI(pathname)),
	    search: search,
	    hash: hash,
	    href: href,
	    origin: origin,
	    protocol: protocol,
	    host: host,
	    hostname: hostname,
	    port: port,
	    state: source.history.state,
	    key: source.history.state && source.history.state.key || "initial"
	  };
	};
	
	var createHistory = function createHistory(source, options) {
	  var listeners = [];
	  var location = getLocation(source);
	  var transitioning = false;
	  var resolveTransition = function resolveTransition() {};
	
	  return {
	    get location() {
	      return location;
	    },
	
	    get transitioning() {
	      return transitioning;
	    },
	
	    _onTransitionComplete: function _onTransitionComplete() {
	      transitioning = false;
	      resolveTransition();
	    },
	    listen: function listen(listener) {
	      listeners.push(listener);
	
	      var popstateListener = function popstateListener() {
	        location = getLocation(source);
	        listener({ location: location, action: "POP" });
	      };
	
	      source.addEventListener("popstate", popstateListener);
	
	      return function () {
	        source.removeEventListener("popstate", popstateListener);
	        listeners = listeners.filter(function (fn) {
	          return fn !== listener;
	        });
	      };
	    },
	    navigate: function navigate(to) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          state = _ref.state,
	          _ref$replace = _ref.replace,
	          replace = _ref$replace === undefined ? false : _ref$replace;
	
	      if (typeof to === "number") {
	        source.history.go(to);
	      } else {
	        state = _extends({}, state, { key: Date.now() + "" });
	        // try...catch iOS Safari limits to 100 pushState calls
	        try {
	          if (transitioning || replace) {
	            source.history.replaceState(state, null, to);
	          } else {
	            source.history.pushState(state, null, to);
	          }
	        } catch (e) {
	          source.location[replace ? "replace" : "assign"](to);
	        }
	      }
	
	      location = getLocation(source);
	      transitioning = true;
	      var transition = new Promise(function (res) {
	        return resolveTransition = res;
	      });
	      listeners.forEach(function (listener) {
	        return listener({ location: location, action: "PUSH" });
	      });
	      return transition;
	    }
	  };
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Stores history entries in memory for testing or other platforms like Native
	var createMemorySource = function createMemorySource() {
	  var initialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	
	  var searchIndex = initialPath.indexOf("?");
	  var initialLocation = {
	    pathname: searchIndex > -1 ? initialPath.substr(0, searchIndex) : initialPath,
	    search: searchIndex > -1 ? initialPath.substr(searchIndex) : ""
	  };
	  var index = 0;
	  var stack = [initialLocation];
	  var states = [null];
	
	  return {
	    get location() {
	      return stack[index];
	    },
	    addEventListener: function addEventListener(name, fn) {},
	    removeEventListener: function removeEventListener(name, fn) {},
	
	    history: {
	      get entries() {
	        return stack;
	      },
	      get index() {
	        return index;
	      },
	      get state() {
	        return states[index];
	      },
	      pushState: function pushState(state, _, uri) {
	        var _uri$split = uri.split("?"),
	            pathname = _uri$split[0],
	            _uri$split$ = _uri$split[1],
	            search = _uri$split$ === undefined ? "" : _uri$split$;
	
	        index++;
	        stack.push({ pathname: pathname, search: search.length ? "?" + search : search });
	        states.push(state);
	      },
	      replaceState: function replaceState(state, _, uri) {
	        var _uri$split2 = uri.split("?"),
	            pathname = _uri$split2[0],
	            _uri$split2$ = _uri$split2[1],
	            search = _uri$split2$ === undefined ? "" : _uri$split2$;
	
	        stack[index] = { pathname: pathname, search: search };
	        states[index] = state;
	      },
	      go: function go(to) {
	        var newIndex = index + to;
	
	        if (newIndex < 0 || newIndex > states.length - 1) {
	          return;
	        }
	
	        index = newIndex;
	      }
	    }
	  };
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// global history - uses window.history as the source if available, otherwise a
	// memory history
	var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
	var getSource = function getSource() {
	  return canUseDOM ? window : createMemorySource();
	};
	
	var globalHistory = createHistory(getSource());
	var navigate = globalHistory.navigate;
	
	////////////////////////////////////////////////////////////////////////////////
	
	exports.globalHistory = globalHistory;
	exports.navigate = navigate;
	exports.createHistory = createHistory;
	exports.createMemorySource = createMemorySource;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.shallowCompare = exports.validateRedirect = exports.insertParams = exports.resolve = exports.match = exports.pick = exports.startsWith = undefined;
	
	var _invariant = __webpack_require__(5);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////////////////////////////////////////////////////////////////////////////////
	// startsWith(string, search) - Check if `string` starts with `search`
	var startsWith = function startsWith(string, search) {
	  return string.substr(0, search.length) === search;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// pick(routes, uri)
	//
	// Ranks and picks the best route to match. Each segment gets the highest
	// amount of points, then the type of segment gets an additional amount of
	// points where
	//
	//     static > dynamic > splat > root
	//
	// This way we don't have to worry about the order of our routes, let the
	// computers do it.
	//
	// A route looks like this
	//
	//     { path, default, value }
	//
	// And a returned match looks like:
	//
	//     { route, params, uri }
	//
	// I know, I should use TypeScript not comments for these types.
	var pick = function pick(routes, uri) {
	  var match = void 0;
	  var default_ = void 0;
	
	  var _uri$split = uri.split("?"),
	      uriPathname = _uri$split[0];
	
	  var uriSegments = segmentize(uriPathname);
	  var isRootUri = uriSegments[0] === "";
	  var ranked = rankRoutes(routes);
	
	  for (var i = 0, l = ranked.length; i < l; i++) {
	    var missed = false;
	    var route = ranked[i].route;
	
	    if (route.default) {
	      default_ = {
	        route: route,
	        params: {},
	        uri: uri
	      };
	      continue;
	    }
	
	    var routeSegments = segmentize(route.path);
	    var params = {};
	    var max = Math.max(uriSegments.length, routeSegments.length);
	    var index = 0;
	
	    for (; index < max; index++) {
	      var routeSegment = routeSegments[index];
	      var uriSegment = uriSegments[index];
	
	      if (isSplat(routeSegment)) {
	        // Hit a splat, just grab the rest, and return a match
	        // uri:   /files/documents/work
	        // route: /files/*
	        var param = routeSegment.slice(1) || "*";
	        params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
	        break;
	      }
	
	      if (uriSegment === undefined) {
	        // URI is shorter than the route, no match
	        // uri:   /users
	        // route: /users/:userId
	        missed = true;
	        break;
	      }
	
	      var dynamicMatch = paramRe.exec(routeSegment);
	
	      if (dynamicMatch && !isRootUri) {
	        var matchIsNotReserved = reservedNames.indexOf(dynamicMatch[1]) === -1;
	        !matchIsNotReserved ?  false ? (0, _invariant2.default)(false, "<Router> dynamic segment \"" + dynamicMatch[1] + "\" is a reserved name. Please use a different name in path \"" + route.path + "\".") : (0, _invariant2.default)(false) : void 0;
	        var value = decodeURIComponent(uriSegment);
	        params[dynamicMatch[1]] = value;
	      } else if (routeSegment !== uriSegment) {
	        // Current segments don't match, not dynamic, not splat, so no match
	        // uri:   /users/123/settings
	        // route: /users/:id/profile
	        missed = true;
	        break;
	      }
	    }
	
	    if (!missed) {
	      match = {
	        route: route,
	        params: params,
	        uri: "/" + uriSegments.slice(0, index).join("/")
	      };
	      break;
	    }
	  }
	
	  return match || default_ || null;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// match(path, uri) - Matches just one path to a uri, also lol
	var match = function match(path, uri) {
	  return pick([{ path: path }], uri);
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// resolve(to, basepath)
	//
	// Resolves URIs as though every path is a directory, no files.  Relative URIs
	// in the browser can feel awkward because not only can you be "in a directory"
	// you can be "at a file", too. For example
	//
	//     browserSpecResolve('foo', '/bar/') => /bar/foo
	//     browserSpecResolve('foo', '/bar') => /foo
	//
	// But on the command line of a file system, it's not as complicated, you can't
	// `cd` from a file, only directories.  This way, links have to know less about
	// their current path. To go deeper you can do this:
	//
	//     <Link to="deeper"/>
	//     // instead of
	//     <Link to=`{${props.uri}/deeper}`/>
	//
	// Just like `cd`, if you want to go deeper from the command line, you do this:
	//
	//     cd deeper
	//     # not
	//     cd $(pwd)/deeper
	//
	// By treating every path as a directory, linking to relative paths should
	// require less contextual information and (fingers crossed) be more intuitive.
	var resolve = function resolve(to, base) {
	  // /foo/bar, /baz/qux => /foo/bar
	  if (startsWith(to, "/")) {
	    return to;
	  }
	
	  var _to$split = to.split("?"),
	      toPathname = _to$split[0],
	      toQuery = _to$split[1];
	
	  var _base$split = base.split("?"),
	      basePathname = _base$split[0];
	
	  var toSegments = segmentize(toPathname);
	  var baseSegments = segmentize(basePathname);
	
	  // ?a=b, /users?b=c => /users?a=b
	  if (toSegments[0] === "") {
	    return addQuery(basePathname, toQuery);
	  }
	
	  // profile, /users/789 => /users/789/profile
	  if (!startsWith(toSegments[0], ".")) {
	    var pathname = baseSegments.concat(toSegments).join("/");
	    return addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
	  }
	
	  // ./         /users/123  =>  /users/123
	  // ../        /users/123  =>  /users
	  // ../..      /users/123  =>  /
	  // ../../one  /a/b/c/d    =>  /a/b/one
	  // .././one   /a/b/c/d    =>  /a/b/c/one
	  var allSegments = baseSegments.concat(toSegments);
	  var segments = [];
	  for (var i = 0, l = allSegments.length; i < l; i++) {
	    var segment = allSegments[i];
	    if (segment === "..") segments.pop();else if (segment !== ".") segments.push(segment);
	  }
	
	  return addQuery("/" + segments.join("/"), toQuery);
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// insertParams(path, params)
	
	var insertParams = function insertParams(path, params) {
	  var _path$split = path.split("?"),
	      pathBase = _path$split[0],
	      _path$split$ = _path$split[1],
	      query = _path$split$ === undefined ? "" : _path$split$;
	
	  var segments = segmentize(pathBase);
	  var constructedPath = "/" + segments.map(function (segment) {
	    var match = paramRe.exec(segment);
	    return match ? params[match[1]] : segment;
	  }).join("/");
	  var _params$location = params.location;
	  _params$location = _params$location === undefined ? {} : _params$location;
	  var _params$location$sear = _params$location.search,
	      search = _params$location$sear === undefined ? "" : _params$location$sear;
	
	  var searchSplit = search.split("?")[1] || "";
	  constructedPath = addQuery(constructedPath, query, searchSplit);
	  return constructedPath;
	};
	
	var validateRedirect = function validateRedirect(from, to) {
	  var filter = function filter(segment) {
	    return isDynamic(segment);
	  };
	  var fromString = segmentize(from).filter(filter).sort().join("/");
	  var toString = segmentize(to).filter(filter).sort().join("/");
	  return fromString === toString;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Junk
	var paramRe = /^:(.+)/;
	
	var SEGMENT_POINTS = 4;
	var STATIC_POINTS = 3;
	var DYNAMIC_POINTS = 2;
	var SPLAT_PENALTY = 1;
	var ROOT_POINTS = 1;
	
	var isRootSegment = function isRootSegment(segment) {
	  return segment === "";
	};
	var isDynamic = function isDynamic(segment) {
	  return paramRe.test(segment);
	};
	var isSplat = function isSplat(segment) {
	  return segment && segment[0] === "*";
	};
	
	var rankRoute = function rankRoute(route, index) {
	  var score = route.default ? 0 : segmentize(route.path).reduce(function (score, segment) {
	    score += SEGMENT_POINTS;
	    if (isRootSegment(segment)) score += ROOT_POINTS;else if (isDynamic(segment)) score += DYNAMIC_POINTS;else if (isSplat(segment)) score -= SEGMENT_POINTS + SPLAT_PENALTY;else score += STATIC_POINTS;
	    return score;
	  }, 0);
	  return { route: route, score: score, index: index };
	};
	
	var rankRoutes = function rankRoutes(routes) {
	  return routes.map(rankRoute).sort(function (a, b) {
	    return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
	  });
	};
	
	var segmentize = function segmentize(uri) {
	  return uri
	  // strip starting/ending slashes
	  .replace(/(^\/+|\/+$)/g, "").split("/");
	};
	
	var addQuery = function addQuery(pathname) {
	  for (var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    query[_key - 1] = arguments[_key];
	  }
	
	  query = query.filter(function (q) {
	    return q && q.length > 0;
	  });
	  return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
	};
	
	var reservedNames = ["uri", "path"];
	
	/**
	 * Shallow compares two objects.
	 * @param {Object} obj1 The first object to compare.
	 * @param {Object} obj2 The second object to compare.
	 */
	var shallowCompare = function shallowCompare(obj1, obj2) {
	  var obj1Keys = Object.keys(obj1);
	  return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function (key) {
	    return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
	  });
	};
	
	////////////////////////////////////////////////////////////////////////////////
	exports.startsWith = startsWith;
	exports.pick = pick;
	exports.match = match;
	exports.resolve = resolve;
	exports.insertParams = insertParams;
	exports.validateRedirect = validateRedirect;
	exports.shallowCompare = shallowCompare;

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(89);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(4);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(82);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blogContainer":"src-components-Blog----blog-module---blogContainer---KG-HT","section":"src-components-Blog----blog-module---section---1QSvF","postContainer":"src-components-Blog----blog-module---postContainer---1SfFa","post":"src-components-Blog----blog-module---post---P8XVf","content":"src-components-Blog----blog-module---content---1TShP"};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blogModule = __webpack_require__(124);
	
	var _blogModule2 = _interopRequireDefault(_blogModule);
	
	var _mfgAccount_loginMin = __webpack_require__(14);
	
	var _mfgAccount_loginMin2 = _interopRequireDefault(_mfgAccount_loginMin);
	
	var _router = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogListCover = function BlogListCover(_ref) {
	    var cover = _ref.cover;
	
	    var _useState = (0, _react.useState)(false),
	        error = _useState[0],
	        setError = _useState[1];
	
	    var onError = function onError() {
	        setError(true);
	    };
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        !error && _react2.default.createElement('img', { src: 'https://eam-dashboard-api-eqcg4.ondigitalocean.app/uploads/' + cover, alt: 'cover', onError: onError })
	    );
	};
	
	exports.default = BlogListCover;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(9);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _blogListCover = __webpack_require__(140);
	
	var _blogListCover2 = _interopRequireDefault(_blogListCover);
	
	var _blogModule = __webpack_require__(124);
	
	var _blogModule2 = _interopRequireDefault(_blogModule);
	
	var _mfgAccount_loginMin = __webpack_require__(14);
	
	var _mfgAccount_loginMin2 = _interopRequireDefault(_mfgAccount_loginMin);
	
	var _router = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPosts = function BlogPosts() {
	  var _useState = (0, _react.useState)([]),
	      posts = _useState[0],
	      setPosts = _useState[1];
	
	  (0, _react.useEffect)(function () {
	    fetch('https://eam-dashboard-api-eqcg4.ondigitalocean.app/api/post').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      return setPosts(json.data);
	    });
	  }, []);
	
	  var onPostClick = function onPostClick(id) {
	    // window.location.href = `/blog/${id}`;
	    (0, _router.navigate)('/blog/' + id);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _blogModule2.default.blogContainer },
	      _react2.default.createElement(_Banner2.default, { src: _mfgAccount_loginMin2.default }),
	      _react2.default.createElement(
	        'div',
	        { className: _blogModule2.default.section },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Blog'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _blogModule2.default.postContainer },
	          posts.map(function (post) {
	            return _react2.default.createElement(
	              'div',
	              { className: _blogModule2.default.post, key: post._id, onClick: function onClick() {
	                  return onPostClick(post._id);
	                } },
	              _react2.default.createElement(_blogListCover2.default, { cover: post.cover }),
	              _react2.default.createElement(
	                'div',
	                { className: _blogModule2.default.content },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  post.title
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  post.short_description
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	// import axios from 'axios'
	// import { navigate } from "gatsby";
	
	exports.default = BlogPosts;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _router = __webpack_require__(27);
	
	var _Blog = __webpack_require__(141);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	var _post = __webpack_require__(56);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { navigate } from "gatsby"
	
	var Blog = function Blog() {
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _router.Router,
	      { basepath: '/blog' },
	      _react2.default.createElement(_post2.default, { path: '/:id' }),
	      _react2.default.createElement(_Blog2.default, { path: '/' }),
	      _react2.default.createElement(_Blog2.default, { 'default': true })
	    )
	  );
	};
	
	exports.default = Blog;
	module.exports = exports['default'];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(9);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _postModule = __webpack_require__(85);
	
	var _postModule2 = _interopRequireDefault(_postModule);
	
	var _mfgAccount_loginMin = __webpack_require__(14);
	
	var _mfgAccount_loginMin2 = _interopRequireDefault(_mfgAccount_loginMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import axios from 'axios'
	
	var Post = function Post() {
	  var _useState = (0, _react.useState)(),
	      data = _useState[0],
	      setData = _useState[1];
	
	  var _useState2 = (0, _react.useState)(),
	      cover = _useState2[0],
	      setCover = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      error = _useState3[0],
	      setError = _useState3[1];
	
	  var onError = function onError() {
	    setError(true);
	  };
	
	  (0, _react.useEffect)(function () {
	    var chunks = window.location.pathname.split('/');
	
	    fetch('https://eam-dashboard-api-eqcg4.ondigitalocean.app/api/post/' + chunks[2]).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      var data = json.data && json.data.length > 0 ? json.data[0] : {};
	      setData(data);
	      if (data.cover && data.cover !== '' && data.cover !== null) {
	        var _cover = 'https://eam-dashboard-api-eqcg4.ondigitalocean.app/uploads/' + data.cover;
	        setCover(_cover);
	      }
	    });
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _postModule2.default.postContainer },
	    _react2.default.createElement(_Banner2.default, { src: _mfgAccount_loginMin2.default }),
	    _react2.default.createElement(
	      'div',
	      { className: _postModule2.default.section },
	      !error && _react2.default.createElement('img', { src: cover, alt: 'cover', onError: onError }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        data ? data.title : ''
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        data ? data.short_description : ''
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: {
	          __html: data ? data.body : ''
	        } })
	    )
	  );
	};
	// import sanitizeHtml from 'sanitize-html';
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"postContainer":"src-pages----post-module---postContainer---3N89j","section":"src-pages----post-module---section---2UP7x","post":"src-pages----post-module---post---20KrA"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-2f6b2c0d1f61fa951ba2.js